import React, { Component } from 'react';
import {DatePicker, message, Select, Table} from 'antd';
import Chart from "react-apexcharts";
import Datatable from './Datatable';
import {map, filter} from 'lodash';
import DataTable from "./Datatable";
import moment from "moment-timezone";
import Loader from "../../Common/Component/Loader";
import {errorHandle} from "../../Common/errorHandle";
import { formatToCurrency } from '../../../Tools/formatToCurrency';

const { Option } = Select;

// pie colors
const pie_colors = ['#407977', '#b3f3d9', '#F99D20', '#CDE059', '#3ba93f', '#abd3d2'];
const pie_colors_class = ['green-1', 'light-green', 'orange-1', 'lime', 'dark-green', 'ripple-green'];
const service_filter_mapping = [{'first_time': 'First Time'}];

class OperationMgrDashboard extends Component {

  state = {
    data: {},

    green_options: {
      chart: {
        toolbar: {
          show: false
        },
      },
      stroke: {
        colors: ['#C1D82F'],
        curve: 'smooth',
        width: 1,
      },
      grid: {
        show: false,
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          show: false,
        }
      },
      yaxis: {
        show: false
      },

      markers: {
        // size: [4, 7],
        // colors: ['#C1D82F'],
      }
    },
    green_series: [{
      name: "Desktops",
      data: [10, 41, 10, 60, 10, 70]
    }],

    serviceTypeCollection: {},
    service_type_options: {
      chart: {
        type: 'donut'
      },
      dataLabels: {
        enabled: false,
      },
      legend: {show: false},
      tooltip: {
        enabled: true,
        custom: ({series, seriesIndex}) => {
          //{series, seriesIndex, dataPointIndex, w}
          return '<div style="background-color: #FFFFFF; padding: 10px; color: #000000">' +
            '<span>' + parseFloat(series[seriesIndex]).toFixed(2) + '</span>' +
            '</div>'
        }
      },
      plotOptions: {
        pie: {
          expandOnClick: true,
          donut: {
            labels: {show: false},
          },
        }
      }
    },
    serviceFilterIdx: 0,
    ticket_filter: '',
    messageData: {},
    messageAssignedToMe: {},
    satisfyMonth: moment(),
    isCustomerSatisfaction: true,
    fullCardIdx: 0,
    isDashboardStat: true,
    isTodayRevenue: true,
    revenueMonth: moment(),
    revenueStat: {},
    scheduleService: {},
    service_filter: '',
    completedServiceMonth: moment(),
    groupList: {}
  }

  componentDidMount = () => {
    const authUser = JSON.parse(localStorage.getItem('authUser'))
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    const data = {uuid: franchise_uuid?.[0]}; //'8b2e407c-240f-4f4b-a758-d117f84889bc'
    this.setState({ data: data, loader: true }, () => {
      const {data, satisfyMonth, completedServiceMonth} = this.state;
      const {is_corporate} = this.getLoggedInUserRole()
      this.props.getAllMessages({user__serviceorder__field_office__uuid: is_corporate ? '' : data?.uuid, limit: 5, offset: 0}) // get Tickets
      this.props.getAssignedToMeMessage({assigned_user__uuid: authUser?.user?.uuid}) // get Tickets assigned to me
      this.props.getServiceTypeCollection({field_office__uuid: data?.uuid, timestamp__gte: moment(completedServiceMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
        timestamp__lte: moment(completedServiceMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}) // get service type collection
      let date = moment(satisfyMonth).format('DD') >= 21 ? moment(satisfyMonth).endOf('month').format('YYYY-MM-DD') : moment(satisfyMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)  // get dashboard stat
      this.props.getScheduleService({schedule_strart_ts__date: moment().format('YYYY-MM-DD'), service__service_order__frequency__iexact: ''})
      this.props.getFranchiseGroupList({field_office__uuid: data?.uuid}) // get group list for logged in user franchise
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()

    ///////////error handle /////////////////////
    if (Object.keys(nextProps?.AllMessages?.errors).length > 0 && nextProps?.AllMessages?.errors !== this.props?.AllMessages?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AllMessages?.errors)
    }

    if (Object.keys(nextProps?.Dashboard?.errors).length > 0 && nextProps?.Dashboard?.errors !== this.props?.Dashboard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Dashboard?.errors)
    }
    /////////////////////////////////////////////

    //get Message
    if (Object.keys(nextProps?.AllMessages?.data).length > 0 && nextProps?.AllMessages?.data !== this.props?.AllMessages?.data) {
      this.setState({messageData: nextProps?.AllMessages?.data, loader: false})
    }

    //get assigned to me
    if (Object.keys(nextProps?.Dashboard?.messageAssignedToMe).length > 0 && nextProps?.Dashboard?.messageAssignedToMe !== this.props?.Dashboard?.messageAssignedToMe) {
      this.setState({messageAssignedToMe: nextProps?.Dashboard?.messageAssignedToMe, loader: false})
    }

    //get service type collection
    if (Object.keys(nextProps?.Dashboard?.serviceTypeCollection).length > 0 && nextProps?.Dashboard?.serviceTypeCollection !== this.props?.Dashboard?.serviceTypeCollection) {
      this.setState({serviceTypeCollection: nextProps?.Dashboard?.serviceTypeCollection, loader: false})
    }

    // get dashboard stat
    if (Object.keys(nextProps?.FranchiseOverview?.dashboardStat).length > 0 && nextProps?.FranchiseOverview?.dashboardStat !== this.props?.FranchiseOverview?.dashboardStat) {
      const {isCustomerSatisfaction, isDashboardStat, isTodayRevenue} = this.state;
      if (isCustomerSatisfaction) {
        this.setState({customerSatisfaction: nextProps?.FranchiseOverview?.dashboardStat?.data, isCustomerSatisfaction: false})
      }
      if (isDashboardStat) {
        this.setState({dashboardStat: nextProps?.FranchiseOverview?.dashboardStat?.data, isDashboardStat: false})
      }
      if (isTodayRevenue) {
        this.setState({revenueStat: nextProps?.FranchiseOverview?.dashboardStat?.data, isTodayRevenue: false})
      }
      this.setState({loader: false})
    }
    
    // get schedule service
    if (Object.keys(nextProps?.Dashboard?.scheduleService).length > 0 && nextProps?.Dashboard?.scheduleService !== this.props?.Dashboard?.scheduleService) {
      this.setState({scheduleService: nextProps?.Dashboard?.scheduleService, loader: false})
    }

    //get group list
    if (Object.keys(nextProps?.Dashboard?.groupList).length > 0 && nextProps?.Dashboard?.groupList !== this.props?.Dashboard?.groupList) {
      this.setState({groupList: nextProps?.Dashboard?.groupList, loader: false})
    }

    this.setState({loader: false})
  }

  // k formatter
  kFormatter = (num) => {
    return Math.abs(num) > 999 ? (Math.sign(num)*((Math.abs(num)/1000).toFixed(1))) + 'k' : Math.sign(num)*Math.abs(num);
  }

  // format amount
  formatAmount = (amount) => {
    return amount?.toString()?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  }

  // calculate growth percentage
  calculateGrowthPercentage = (last_val, curr_val) => {
    let divider = last_val
    if (divider === 0) divider = 1
    return parseFloat(((curr_val - last_val) * 100) / divider).toFixed(2)
  }

  // on change satisfaction month
  onChangeSatisfactionMonth = (e) => {
    this.setState({satisfyMonth: e ? e : moment(), isCustomerSatisfaction: true, loader: true}, () => {
      const {data, satisfyMonth} = this.state;
      const date = moment(satisfyMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // on change revenue month
  onChangeRevenueMonth = (e) => {
    this.setState({revenueMonth: e ? e : moment(), isTodayRevenue: true, loader: true}, () => {
      const {data, revenueMonth} = this.state;
      const date = moment(revenueMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // on change completed service month
  onCompetedServiceMonth = (e) => {
    this.setState({completedServiceMonth: e ? e : moment(), loader: true}, () => {
      const {data, completedServiceMonth} = this.state;
      this.props.getServiceTypeCollection({field_office__uuid: data?.uuid,
        timestamp__gte: moment(completedServiceMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
        timestamp__lte: moment(completedServiceMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}) // get completed service
    })
  }

  // on schedule service filter change
  onScheduleServiceFilterChange = (e) => {
    this.setState({service_filter: e, loader: true}, () => {
      const {service_filter} = this.state;
      this.props.getScheduleService({schedule_strart_ts__date: moment().format('YYYY-MM-DD'), service__service_order__frequency__iexact: service_filter})
    })
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_corporate = logged_in_user_role?.includes('admin')
    return {is_corporate}
  }

  // on ticket filter change
  onTicketFilterChange = (e) => {
    this.setState({ticket_filter: e, loader: true}, () => {
      const {data, ticket_filter} = this.state;
      const {is_corporate} = this.getLoggedInUserRole()
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      let obj = {};
      if (ticket_filter === "me") obj = {assigned_user__uuid: authUser?.user?.uuid}
      else obj = {user__serviceorder__field_office__uuid: is_corporate ? '' : data?.uuid, assigned_group__uuid: ticket_filter}
      this.props.getAllMessages({...obj ,limit: 5, offset: 0}) // get Tickets
    })
  }

  // on change product month
  onChangeFullCardMonth = (e) => {
    this.setState({fullCardIdx: e, loader: true, isDashboardStat: true}, () => {
      const {fullCardIdx, data} = this.state;
      let timestamp__gte = '', timestamp__lte = '';
      let date = moment().format('DD') >= 21 ? moment().endOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      if (fullCardIdx === 0) {
        timestamp__gte = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss')
        timestamp__lte = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss')
        this.props.getDashboardStat(`?franchises_uuid=${data?.uuid}&date=${date}&timestamp__gte=${timestamp__gte}&timestamp__lte=${timestamp__lte}`)
      } else if (fullCardIdx === 1) {
        timestamp__gte = moment().startOf('week').format('YYYY-MM-DDTHH:mm:ss')
        timestamp__lte = moment().endOf('week').format('YYYY-MM-DDTHH:mm:ss')
        this.props.getDashboardStat(`?franchises_uuid=${data?.uuid}&date=${date}&timestamp__gte=${timestamp__gte}&timestamp__lte=${timestamp__lte}`)
      } else {
        this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
      }
    })
  }

  // render full card
  renderCustomerSatisfaction = () => {
    const {satisfyMonth, customerSatisfaction} = this.state;
    let card_list = [{
      count: customerSatisfaction?.customer_satisfaction_last_year?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.customer_satisfaction_last_year, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(1, 'year').format('MMM YYYY')
    }, {
      count: customerSatisfaction?.previous_month_customer_satisfaction?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.previous_month_customer_satisfaction, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(1, 'month').format('MMM YYYY')
    }, {
      count: customerSatisfaction?.four_month_back_customer_satisfaction?.toString(), title: '',
      progress: parseFloat(this.calculateGrowthPercentage(customerSatisfaction?.four_month_back_customer_satisfaction, customerSatisfaction?.customer_satisfaction)).toFixed(2).toString(),
      month: moment(satisfyMonth).subtract(4, 'month').format('MMM YYYY')
    }]
    return (
      <div className="middle_grid card flex flex-start flex-wrap">
        <div className="card-body flex flex-wrap">
          <div className="small_chart fitem flex-auto mr-2">
            <h6>Customer Satisfaction</h6>
            <DatePicker
              disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
              onChange={this.onChangeSatisfactionMonth}
              className="swhite summry_date_picker"
              format="MMMM YYYY"
              picker="month"
              value={satisfyMonth ? satisfyMonth : moment()}  />
          </div>
          {
            map(card_list, (item, index) => {
              return (
                <div className="small_chart flex-auto mr-2" key={`full_card${index}`}>
                  <div className="details">
                    <h2>{parseFloat(item?.count).toFixed(2)}<small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}% {item?.link}
                      </span>
                      <p className="mb-0">Compared to {item?.month}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  // render schedule service
  renderScheduleService = () => {
    const {scheduleService, service_filter} = this.state;

    return (
      <div className="scheduled">
        <div className="card h-650">
          <div className="card-title flex ai-center">
            <h3 className="font-weight-bold">Today’s Scheduled Services</h3>
            {/*<Select*/}
            {/*  width="150px"*/}
            {/*  showArrow*/}
            {/*  virtual={false}*/}
            {/*  value={service_filter}*/}
            {/*  className="from-control"*/}
            {/*  onChange={(e) => this.onScheduleServiceFilterChange(e) }*/}
            {/*>*/}
            {/*  <Option value="first_time">First Time</Option>*/}
            {/*</Select>*/}
          </div>
          <div className="card-body px-0 pt-0">
            <Table
              columns={Datatable.AllMessageList()}
              dataSource={scheduleService?.results}
              className="table invoice_table invoice_table_web table-pl-space"
            />
            <div className="px-20">
              <div className="greenbox"><h2>{scheduleService?.results?.length}</h2><b>{service_filter_mapping[service_filter]} Services Scheduled for Today</b></div>
              <u className="success mt-10 cursor-pointer" onClick={() => {this.props.history.push(`field_tech/week_setup`, {query : { 'value' : 'dashboard'}})}}><b>Go to All Services</b></u>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //render tickets
  renderTickets = () => {
    const {messageData, ticket_filter, messageAssignedToMe, groupList} = this.state;
    const high_priority = filter(messageAssignedToMe?.results, x => x.priority === '3')

    return (
      <div className="ticket">
        <div className="card h-650">
          <div className="card-title flex ai-center" style={{padding: "10px 20px"}}>
            <h3 className="font-weight-bold">Tickets</h3>
            <Select
              placeholder="Assigned To"
              showArrow
              virtual={false}              
              value={ticket_filter}
              allowClear={true}
              className="from-control"
              onChange={(e) => this.onTicketFilterChange(e) }>
              <Option value={"me"} key={"me"}>{`Assigned to me`}</Option>
              {map(groupList?.results, (item) => {
                return (<Option value={item?.uuid} key={item?.uuid}>{item?.name}</Option>)
              })}
            </Select>
          </div>
          <div className={'card-body px-0 pt-0'}>
            <Table
              rowKey={record => record.uuid}
              dataSource={messageData?.results}
              pagination={false}
              columns={DataTable.OperationMgrTicketList(this)}
              // onChange={this.onInvoiceChange}
              className="table invoice_table invoice_table_web table-pl-space"
            />
            <div className="px-20">
              <div className="greenbox flex">
                <div>
                  <h2 className={'success'}>{messageAssignedToMe?.results?.length}</h2>
                  <b>Tickets assigned to me</b>
                </div>
                <div>
                  <h2 className={'danger'}>{high_priority?.length}</h2>
                  <b>High Priority</b>
                </div>
              </div>
              <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/case-management', {table: 'assignedTickets'})}}><u className="success mt-10"><b>Go to Ticket Center</b></u></a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //render service chart
  renderServiceChart = () => {
    const { service_type_options, serviceTypeCollection, serviceFilterIdx, completedServiceMonth} = this.state;
    let total = 0, service_series = new Array(6).fill(0), service_legend = [];
    // series[0] = weekly, series[1] = EOW, series[2] = one time, series[3] = initial clean, series[4] = twice weekly, series[5] = other
    map(serviceTypeCollection?.results, x => {
      if (serviceFilterIdx === 0 && x?.service_type === 'residential') {
        switch (x?.frequency) {
        case 'weekly':
          service_series[0] = service_series[0] + x?.revenue
          break;
        case 'EOW':
          service_series[2] = service_series[1] + x?.revenue
          break;
        case 'once':
          service_series[2] = service_series[2] + x?.revenue
          break;
        case 'initial_clean':
          service_series[3] = service_series[3] + x?.revenue
          break;
        case 'twice_weekly':
          service_series[4] = service_series[4] + x?.revenue
          break;
        default:
          service_series[5] = service_series[5] + x?.revenue
        }
      } else if (serviceFilterIdx === 1 && x?.service_type === 'commercial') {
        switch (x?.frequency) {
        case 'weekly':
          service_series[0] = service_series[0] + x?.revenue
          break;
        case 'EOW':
          service_series[2] = service_series[1] + x?.revenue
          break;
        case 'once':
          service_series[2] = service_series[2] + x?.revenue
          break;
        case 'initial_clean':
          service_series[3] = service_series[3] + x?.revenue
          break;
        case 'twice_weekly':
          service_series[4] = service_series[4] + x?.revenue
          break;
        default:
          service_series[5] = service_series[5] + x?.revenue
        }
      }
    })

    service_legend = [{uuid: 0, name: 'Weekly', revenue: service_series[0]}, {uuid: 1, name: 'EOW', revenue: service_series[1]},
      {uuid: 2, name: 'One Time', revenue: service_series[2]}, {uuid: 3, name: 'Initial Clean', revenue: service_series[3]},
      {uuid: 4, name: 'Twice Weekly', revenue: service_series[4]}, {uuid: 5, name: 'Other', revenue: service_series[5]},
    ]

    map(serviceTypeCollection?.results, x => {
      if (serviceFilterIdx === 0 && x?.service_type === 'residential') total += x?.revenue
      else if (serviceFilterIdx === 1 && x?.service_type === 'commercial') total += x?.revenue
    })

    return (
      <div className="card">
        <div className="card-body pb-0">
          <div className="flex ai-center">
            <h3>Completed Services</h3>
            <div className="d-flex justify-content-between">
              <ul className="tabs mwhite d-block">
                <li className={serviceFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({serviceFilterIdx: 0})}><span>Residential</span></li>
                <li className={serviceFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({serviceFilterIdx: 1})}><span>Commercial</span></li>
              </ul>
              <div className="only-icon-datepick" style={{display: "flex", justifyContent: "flex-end"}}>
                <DatePicker               
                  disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                  onChange={this.onCompetedServiceMonth}
                  className="swhite summry_date_picker"
                  format="MMM YYYY"
                  picker="month"
                  allowClear={false}
                  value={completedServiceMonth ? completedServiceMonth : moment()}  />

              </div>
            </div>
          </div>
          <div className="card-body flex px-0">
            {
              service_series?.every(item => item === 0) ?
                <Chart
                  ref={(ref) => this.emptyProductChart = ref}
                  type="donut"
                  options={{...service_type_options, colors: ['#ecebeb'], tooltip: {enabled: false}, states: {hover: 'none'} }}
                  series={[0.1]} className="donat-block" /> :
                <Chart
                  type="donut"
                  options={{...service_type_options, colors: pie_colors}}
                  series={service_series} className="donat-block"/>
            }
            <ul className="chart_details_list">
              {map(service_legend, (item, index) => {
                if (item?.revenue) {
                  return (
                    <li key={item?.uuid} className={pie_colors_class[index]}>
                      <span>{serviceFilterIdx === 0 ? 'Residential ' : 'Commercial '} {item?.name}</span>
                      <span>${formatToCurrency(item?.revenue)}</span>
                      <span>{item?.revenue ? parseFloat((item?.revenue * 100) / total).toFixed(2) : '0.00'}%</span>
                    </li>
                  )
                }
              } )}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  //render completed service bottom section
  renderCompletedServiceBottom = (item, index) => {
    let { green_options, green_series } = this.state;
    return (
      <li key={`completed_service_bottom${index}`}>
        <div className="card">
          <div className="card-body px-20 py-15">
            <div className="small_chart flex">
              <div className="details">
                <h2>{item?.amount ? this.formatAmount(item?.amount) : '0.00'}<small>{item?.text}</small></h2>
                <div className="graph_count">
                  <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                    <i className={`las ${parseFloat(item?.progress) !== '0' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}%
                  </span>
                  <p className="mb-0">{item?.sub_text}</p>
                </div>
              </div>
              <div className="chart">
                <Chart
                  options={green_options}
                  series={green_series}
                  type="line"
                  width="180"
                  height="80"
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    )
  }

  // render today's revenue
  renderTodayRevenue = () => {
    const {revenueMonth, revenueStat, green_options, green_series} = this.state;
    const todayRevenue = {amount: revenueStat?.today_revenue?.toString(), text: `Today's Revenue`,
      progress: this.calculateGrowthPercentage(revenueStat?.yesterday_revenue, revenueStat?.today_revenue)?.toString(),
      sub_text: 'Compared to Yesterday'}

    return (
      <div className="middle_grid card">
        <div className="px-20 flex justify-content-between" style={{alignItems: "center"}}>
          <h2>${parseInt(todayRevenue?.amount) ? this.kFormatter(todayRevenue?.amount) : '0.00'}</h2>
          <div className="fs-13 lh-17 max-51 font-weight-bold">{todayRevenue?.text}</div>
          <div className="graph_count">
            <span className={`${todayRevenue?.progress?.includes('-') ? 'danger' : ''}`}>
              <i className={`las ${todayRevenue?.progress !== '0.00' ? todayRevenue?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {todayRevenue?.progress ? Math.abs(todayRevenue?.progress?.substr(1)) : '0'}%
            </span>
            <p className="mb-0">{todayRevenue?.sub_text}</p>
          </div>
          <div className="chart">
            <Chart
              options={green_options}
              series={green_series}
              type="line"
              width="180"
              height="80"
            />
          </div>
          <div className="only-icon-datepick" style={{display: "flex", justifyContent: "flex-end"}}>
            <DatePicker
              disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
              onChange={this.onChangeRevenueMonth}
              className="swhite summry_date_picker"
              format="MMM YYYY"
              picker="month"
              allowClear={false}
              value={revenueMonth ? revenueMonth : moment()}  />
          </div>
        </div>
      </div>
    )
  }

  // render full card
  renderFullCard = () => {
    const {dashboardStat, fullCardIdx} = this.state;
    let card_list = [];
    if (fullCardIdx === 0) { // need to change
      card_list = [{
        count: dashboardStat?.new_customers?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: dashboardStat?.cancelled_customers?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }]
    } else if (fullCardIdx === 1) { // need to change
      card_list = [{
        count: dashboardStat?.new_customers_this_year?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers_this_year).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: dashboardStat?.cancelled_customers_this_year?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers_this_year).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }]
    } else if (fullCardIdx === 2) {
      card_list = [{
        count: dashboardStat?.new_customers_all_time?.toString(), title: 'New Customers',
        progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers_all_time).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }, {
        count: dashboardStat?.cancelled_customers_all_time?.toString(), title: 'Cancellation',
        progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers_all_time).toString(),
        month: dashboardStat?.current_month, /*link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>*/
      }]
    }

    return (
      <div className="middle_grid card">
        <div className="card-body px-20 py-15 flex justify-content-between align-items-center">
          <div className="small_chart fitem flex-auto mr-2 w-auto">
            <ul className="tabs mwhite d-block">
              <li className={fullCardIdx === 0 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(0)}><span>Today</span></li>
              <li className={fullCardIdx === 1 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(1)}><span>Week</span></li>
              <li className={fullCardIdx === 2 ? `active` : ''} onClick={() => this.onChangeFullCardMonth(2)}><span>Month</span></li>

            </ul>
          </div>
          {
            map(card_list, (item, index) => {
              return (
                <div className="small_chart flex-auto mr-2 w-auto" key={`full_card${index}`}>
                  <div className="details">
                    <h2>{item?.count}<small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {item?.progress ? Math.abs(item?.progress?.substr(1)) : '0'}% {item?.link}
                      </span>
                      <p className="mb-0">Compared to last {item?.month}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  render() {
    const {dashboardStat, loader} = this.state;
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";

    const completed_service_bottom_cards = [{
      amount: dashboardStat?.technician_stops_today?.toString() || '0.00',
      text: 'Stops Today',
      progress: this.calculateGrowthPercentage(dashboardStat?.technician_stops_yesterday, dashboardStat?.technician_stops_today)?.toString(),
      sub_text: 'Compared to yesterday'
    },{
      amount: dashboardStat?.technician_stops_ytd?.toString() || '0.00',
      text: 'Stops YTD',
      progress: this.calculateGrowthPercentage(dashboardStat?.technician_stops_last_ytd, dashboardStat?.technician_stops_ytd)?.toString(),
      sub_text: `Compared ${moment().format('MMMM DD')}`
    },{
      amount: dashboardStat?.technician_stops_mtd?.toString() || '0.00',
      text: 'Stops MTD',
      progress: this.calculateGrowthPercentage(dashboardStat?.technician_stops_last_month, dashboardStat?.technician_stops_mtd)?.toString(),
      sub_text: `Compared to ${moment().subtract(1, 'month').format('MMM')}`
    },{
      amount: dashboardStat?.calls_logged?.toString() || '0.00',
      text: 'Call Logged',
      progress: this.calculateGrowthPercentage(dashboardStat?.previous_month_calls_logged, dashboardStat?.calls_logged)?.toString(),
      sub_text: 'in the las 24h'
    }]

    return (
      <div className="dashboard_wrapper block-row w-1596">
        {loader && <Loader />}
        <div className="overview_wrapper">
          <div className="res-head mb-20">
            <h3 className="mb-0">Welcome, {user?.first_name} {user?.last_name}! Dashboard features will be coming soon!</h3>
          </div>

          {/* <div className="details_section main-outer d-flex">
            <div className="left left-outer">
              First Section
              {this.renderCustomerSatisfaction()}
              Scheduled  and Ticket Details
              <div className="scheduled_ticket_section scheduling">
                {this.renderScheduleService()}
                {this.renderTickets()}
              </div>
            </div>

            <div className="right right-outer">
              {this.renderServiceChart()}
              <div className="chart_bottom mt-20">
                <ul className="chart_bottom-50">
                  {map(completed_service_bottom_cards, this.renderCompletedServiceBottom)}
                </ul>
              </div>
              {this.renderTodayRevenue()}
              {this.renderFullCard()}
             
            </div>

          </div> */}
        </div>
      </div>
    );
  }
}

export default OperationMgrDashboard;